import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop, isString } from 'lodash';
import { AnalyticsService, VIRTUAL_PAGEVIEWS as PAGES, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import 'trade-in-360/components/InstantEstimateWrapper/Components/ConfirmationMessageTrade360/ConfirmationMessageTrade360.scss';
import ActionButton from '../ActionButton/ActionButton.jsx';
import CONFIRMATION_TYPE from '../../../../constants/confirmationType.js';

const ConfirmationMessageTrade360 = ({ title, description, icon, closeText, onClose, children, confirmationType }) => {
    useEffect(() => {
        switch (confirmationType) {
            case CONFIRMATION_TYPE.SAVE:
                AnalyticsService.virtualPageView(PAGES.TRADE_IN_THANK_YOU_SAVE_ESTIMATE());
                break;
            case CONFIRMATION_TYPE.APPOINTMENT:
                AnalyticsService.virtualPageView(PAGES.TRADE_IN_APPONTMENT_THANK_YOU());
                break;
            case CONFIRMATION_TYPE.OFFICIAL_PARTIAL:
                AnalyticsService.virtualPageView(PAGES.TRADE_IN_OFFICIAL_PARTIAL_THANK_YOU());
                break;
            case CONFIRMATION_TYPE.OFFICIAL_COMPLETED:
                AnalyticsService.virtualPageView(PAGES.TRADE_IN_OFFICIAL_COMPLETED_THANK_YOU());
                break;
            default:
                break;
        }
    }, []);

    const handleClose = () => {
        AnalyticsService.ga4Trigger(TAGS.TRADE_IN_DONE_BTN());
        onClose();
    };

    return (
        <div className="confirmation-message-trade360">
            <div className="confirmation-message-trade360-header">
                <h4
                    className="confirmation-message-trade360-header--title"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                />
            </div>
            <div className="confirmation-message-trade360--radio">
                {icon === 'success' && <icon className="icon-tradein-icon-options" />}
                {icon === 'warning' && <div className="icon-warning">!</div>}
            </div>
            <div className="confirmation-message-trade360--desc body1 body">
                {isString(description) ? (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                ) : (
                    description
                )}
            </div>
            <div className="vehicle-buttons-container">
                <div className={`vehicle-buttons ${children ? '' : 'center'}`}>
                    {children}
                    {closeText &&
                        onClose && (
                            <ActionButton next noArrow noPrefix center onClick={handleClose}>
                                {closeText}
                            </ActionButton>
                        )}
                </div>
            </div>
        </div>
    );
};

ConfirmationMessageTrade360.defaultProps = {
    closeText: null,
    icon: 'success',
    onClose: noop,
    children: null,
    confirmationType: '',
};

ConfirmationMessageTrade360.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.oneOf(['success', 'warning']),
    closeText: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.element,
    confirmationType: PropTypes.oneOf([
        CONFIRMATION_TYPE.SAVE,
        CONFIRMATION_TYPE.APPOINTMENT,
        CONFIRMATION_TYPE.OFFICIAL_PARTIAL,
        CONFIRMATION_TYPE.OFFICIAL_COMPLETED,
    ]),
};

ConfirmationMessageTrade360.displayName = 'ConfirmationMessageTrade360';

export default ConfirmationMessageTrade360;
